import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, SlidersHorizontal } from 'lucide-react';
import { RouteCard } from '../components/RouteCard';
import { motion } from 'framer-motion';
export function ResultsPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'ai' | 'all'>('ai');
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-367">
      {/* Header */}
      <div className="bg-white sticky top-0 z-30 shadow-sm" data-id="element-368">
        <div className="px-4 py-4 flex items-center justify-between" data-id="element-369">
          <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full" data-id="element-370">
            <ArrowLeft size={24} className="text-gray-700" data-id="element-371" />
          </button>
          <div className="text-center" data-id="element-372">
            <h1 className="font-bold font-bengali text-lg" data-id="element-373">ঢাকা ➝ ভোলা</h1>
            <p className="text-xs text-gray-500 font-bengali" data-id="element-374">
              আজ • ১ জন যাত্রী
            </p>
          </div>
          <button className="p-2 hover:bg-gray-100 rounded-full" data-id="element-375">
            <SlidersHorizontal size={24} className="text-gray-700" data-id="element-376" />
          </button>
        </div>

        {/* Tabs */}
        <div className="flex border-b border-gray-200 px-4" data-id="element-377">
          <button onClick={() => setActiveTab('ai')} className={`flex-1 py-3 text-center font-bold font-bengali relative ${activeTab === 'ai' ? 'text-[#006a4e]' : 'text-gray-500'}`} data-id="element-378">
            AI রিকমেন্ডেড
            {activeTab === 'ai' && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-1 bg-[#006a4e] rounded-t-full" data-id="element-379" />}
          </button>
          <button onClick={() => setActiveTab('all')} className={`flex-1 py-3 text-center font-bold font-bengali relative ${activeTab === 'all' ? 'text-[#006a4e]' : 'text-gray-500'}`} data-id="element-380">
            সব অপশন
            {activeTab === 'all' && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-1 bg-[#006a4e] rounded-t-full" data-id="element-381" />}
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4" data-id="element-382">
        {activeTab === 'ai' && <div className="bg-[#006a4e]/5 p-4 rounded-xl border border-[#006a4e]/10 mb-6" data-id="element-383">
            <div className="flex items-start space-x-3" data-id="element-384">
              <span className="text-2xl" data-id="element-385">🤖</span>
              <div data-id="element-386">
                <p className="font-bold text-[#006a4e] font-bengali text-lg" data-id="element-387">
                  আপনার জন্য সেরা রুট
                </p>
                <p className="text-[#004d38] text-sm font-bengali mt-1" data-id="element-388">
                  কম খরচে এবং কম সময়ে পৌঁছানোর জন্য এই রুটটি বেছে নিন।
                </p>
              </div>
            </div>
          </div>}

        <RouteCard type="recommended" duration="৫ ঘণ্টা ৩০ মি" priceRange="৳৪৫০ - ৳৬০০" modes={['বাস/কার', 'লঞ্চ']} onClick={() => navigate('/path-finder')} data-id="element-389" />

        <RouteCard type="cheapest" duration="৭ ঘণ্টা" priceRange="৳৩৫০ - ৳৪৫০" modes={['বাস', 'লঞ্চ']} onClick={() => navigate('/path-finder')} data-id="element-390" />

        <RouteCard type="fastest" duration="৪ ঘণ্টা" priceRange="৳১,২০০ - ৳১,৫০০" modes={['কার', 'স্পিডবোট']} onClick={() => navigate('/path-finder')} data-id="element-391" />
      </div>
    </div>;
}